import { Component, ErrorInfo, ReactNode } from "react";

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
	error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
	public state: State = {
		hasError: false,
		error: null,
	};

	public static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error };
	}

	public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
		console.error("Uncaught error:", error, errorInfo);
	}

	public render() {
		if (this.state.hasError) {
			return (
				<div className="min-h-screen flex items-center justify-center bg-background">
					<div className="max-w-md w-full p-6 text-center">
						<h1 className="text-2xl font-bold text-destructive mb-4">
							Oops! Something went wrong
						</h1>
						<p className="text-muted-foreground mb-6">
							{this.state.error?.message || "An unexpected error occurred"}
						</p>
						<button
							onClick={() => {
								this.setState({ hasError: false, error: null });
								window.location.href = "/";
							}}
							className="inline-flex items-center justify-center rounded-md text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2">
							Return to Home
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}
